import { create } from 'apisauce';

export const api = create({
    baseURL: 'https://api.pay1data.com.ng'
});

// dev

// export const api = create({
//   baseURL: 'http://192.168.43.30:5000',
// });
